import { value } from '@takeshape/util';
import { branding } from "../config.js";
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
const serviceProvider = {
    name: 'vercel',
    title: 'Vercel',
    description: 'Vercel is a deployment option.',
    categories: ['hosting'],
    links: [
        { title: 'Homepage', url: 'https://www.vercel.com/' },
        {
            title: 'Access Tokens [Vercel]',
            url: 'https://vercel.com/account/tokens'
        },
        {
            title: 'Access Tokens [Vercel Guide]',
            url: 'https://vercel.com/guides/how-do-i-use-a-vercel-api-access-token'
        },
        {
            title: `Docs [${branding.productName}]`,
            url: '/docs/services/providers/vercel'
        }
    ],
    serviceType: 'deployment',
    createId: value('vercel'),
    getFormSchema: value({
        type: 'object',
        properties: {
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    token: {
                        '@sensitive': true,
                        title: 'Access Token',
                        type: 'string'
                    }
                },
                required: ['token']
            }
        },
        required: ['authentication']
    }),
    getFormConfig: value({
        order: ['authentication'],
        properties: {
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig: (formData) => updateAuthentication({
        id: 'vercel',
        title: 'Vercel',
        provider: 'vercel',
        serviceType: 'deployment',
        authenticationType: 'bearer'
    }, formData, { type: 'bearer' }),
    isCompleteConfig: hasEveryKey(['authentication'])
};
export default serviceProvider;
